import { render, staticRenderFns } from "./chooseFromOrganization.vue?vue&type=template&id=bd21d1a4&scoped=true"
import script from "./chooseFromOrganization.vue?vue&type=script&lang=js"
export * from "./chooseFromOrganization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd21d1a4",
  null
  
)

export default component.exports